import { Routes } from '../../routes-table';

const getEventRoutes = () => [
        Routes.EventManage,
        Routes.Meetings,
        Routes.OrganizationsList,
        Routes.AttendeesList,
        Routes.EventsList,
        Routes.RoomsList,
        Routes.ConnectionsList,
        Routes.Assets,
        Routes.Artifacts,
        Routes.PassportEdit,
        Routes.Reports,
        Routes.Control,
];

export { getEventRoutes };